export default __webpack_public_path__ + "static/dark-theme-image-6f35e745c6b3f25b9ed3b7d5fab1ec72.png";